/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 17.031,
    height: 17.031,
    viewBox: '0 0 17.031 17.031',
    data: '<defs/><path pid="0" id="close" class="cls-1" d="M720.6 20.128l-1.383-1.383-7.138 7.138-7.137-7.138-1.384 1.383 7.137 7.138-7.142 7.134 1.384 1.383 7.137-7.137 7.138 7.137L720.6 34.4l-7.137-7.138z" transform="translate(-703.563 -18.75)"/>'
  }
})
